import { Link, Typography } from '@one-thd/sui-atomic-components';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { returnPolicyURL } from '../../../constants/cancels';
import { EDIT_PICKUP_PERSON_ALERT_MESSAGE } from '../../../constants/editPickupPerson';
import { EDIT_DELIVERY_PO_ERROR, GENERAL_DRAWER_ERROR, CDA_BODFS_EXCLUDED_SHIP_STATE_DRAWER_ERROR, MULTI_SHIPMENT_BANNER_TEXT, } from '../../../constants/order-details';
import { REVIEW_PICK_UP_OPTIONS } from '../../../constants/order-details-alert-messages';
import { ERR_GENERIC_LATER } from '../../../constants/response-error-messages';
import { ORDER_STATUS_MESSAGE } from '../../../constants/status';
import { useOrderContext } from '../../../hooks/useContexts';
import { getWindow } from '../../../utils/general';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { EditDeliveryAddressAlertType } from '../../../models/edit-delivery-address';
import { TrackEditDeliveryAddressAnalytics, TrackErrorEventEditDeliveryAddressAnalytics, TrackErrorPageEditDeliveryAddressAnalytics, } from '../../../utils/edit-delivery-address/analytics';
import { TrackErrorEventBopisOosrAnalytics } from '../../../utils/bopis/bopis-oosr-analytics';
var availableSlotsErrorBanner = function (availableSlotsRef) { return [
    React.createElement("div", { ref: availableSlotsRef, tabIndex: -1, key: "availableSlotsErrorBanner" },
        React.createElement(AlertBanner, { status: "error" }, "There was a temporary technical error. Please try again shortly.")),
]; };
var rescheduleBanner = function (resp) {
    var message = '';
    var status = 'info';
    var state = resp === null || resp === void 0 ? void 0 : resp.state;
    if (state === 'success') {
        message = 'Your delivery was successfully rescheduled.';
        status = 'success';
    }
    return React.createElement(AlertBanner, { status: status }, message);
};
export var Alerts = function (_a) {
    var orderNumber = _a.orderNumber, alertState = _a.alertState, availableSlotsError = _a.availableSlotsError, editPickupPersonState = _a.editPickupPersonState, fulfillmentGroup = _a.fulfillmentGroup, isDfsReschedulable = _a.isDfsReschedulable, isFirstShipment = _a.isFirstShipment, onCloseBackorderBanner = _a.onCloseBackorderBanner, onCloseMultiShipmentBanner = _a.onCloseMultiShipmentBanner, reschedulable = _a.reschedulable, showBackorderBanner = _a.showBackorderBanner, showDrawerError = _a.showDrawerError, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, showMultiShipmentBanner = _a.showMultiShipmentBanner, showPickupPersonFraudError = _a.showPickupPersonFraudError, updatedBannerState = _a.updatedBannerState, isBopisOutOfStock = _a.isBopisOutOfStock;
    var _b = useOrderContext(), showReasonCodesApiError = _b.showReasonCodesApiError, showDeliveryAddressesApiError = _b.showDeliveryAddressesApiError, showDeliveryAvailableSlotsApiError = _b.showDeliveryAvailableSlotsApiError, showExcludedShipStateApiError = _b.showExcludedShipStateApiError;
    var _c = useState(), editPickupLocationNewOrderId = _c[0], setEditPickupLocationNewOrderId = _c[1]; // For Loading Button
    var _d = useState(), editDeliveryAddressNewOrderId = _d[0], setEditDeliveryAddressNewOrderId = _d[1];
    var _e = useState(false), editDeliveryAddressPOError = _e[0], setEditDeliveryAddressPOError = _e[1];
    var location = useLocation();
    var availableSlotsRef = useRef(null);
    var unavailableRef = useRef(null);
    var editPickupPersonRef = useRef(null);
    var genericErrorRef = useRef(null);
    var excludedShipStateErrorRef = useRef(null);
    var showExcludedShipStateError = showExcludedShipStateApiError[fulfillmentGroupIndex];
    var showGenericError = showDrawerError === fulfillmentGroupIndex ||
        showReasonCodesApiError[fulfillmentGroupIndex] === true ||
        showDeliveryAddressesApiError[fulfillmentGroupIndex] === true ||
        showDeliveryAvailableSlotsApiError[fulfillmentGroupIndex] === true;
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var lineIds = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.lineId; });
        var editPickupLocationOrderIds = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.getItem('editPickupLocationOrderIds');
        var editDeliveryAddressAlert = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.sessionStorage.getItem('editDeliveryAddressAlert');
        if (editPickupLocationOrderIds &&
            lineIds &&
            ((_f = (_e = (_d = JSON.parse(editPickupLocationOrderIds)) === null || _d === void 0 ? void 0 : _d.orderIds) === null || _e === void 0 ? void 0 : _e.originalOrder) === null || _f === void 0 ? void 0 : _f.orderId) === orderNumber &&
            lineIds.some(function (id) { var _a; return id === ((_a = JSON.parse(editPickupLocationOrderIds)) === null || _a === void 0 ? void 0 : _a.lineId); })) {
            setEditPickupLocationNewOrderId(JSON.parse(editPickupLocationOrderIds).orderIds.newOrder.orderId);
            (_g = getWindow()) === null || _g === void 0 ? void 0 : _g.sessionStorage.removeItem('editPickupLocationOrderIds');
        }
        if (isBopisOutOfStock) {
            TrackErrorEventBopisOosrAnalytics('order details', 'n/a', 'These items have been canceled.', 'ad');
        }
        if (editDeliveryAddressAlert &&
            lineIds &&
            lineIds.some(function (id) { var _a; return id === ((_a = JSON.parse(editDeliveryAddressAlert)) === null || _a === void 0 ? void 0 : _a.lineId); })) {
            var alertType = JSON.parse(editDeliveryAddressAlert).alert;
            if (((_h = JSON.parse(editDeliveryAddressAlert)) === null || _h === void 0 ? void 0 : _h.orderId) === orderNumber &&
                alertType === EditDeliveryAddressAlertType.EDIT_DELIVERY_SUCCESS) {
                setEditDeliveryAddressNewOrderId(JSON.parse(editDeliveryAddressAlert).newOrderId);
            }
            else if (alertType === EditDeliveryAddressAlertType.EDIT_DELIVERY_PO_ERROR) {
                setEditDeliveryAddressPOError(true);
                TrackErrorEventEditDeliveryAddressAnalytics('edit delivery address > edit form', 'n/a', EDIT_DELIVERY_PO_ERROR, 'system');
            }
            (_j = getWindow()) === null || _j === void 0 ? void 0 : _j.sessionStorage.removeItem('editDeliveryAddressAlert');
        }
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (availableSlotsError && availableSlotsRef.current) {
            availableSlotsRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
            (_b = (_a = availableSlotsRef.current).focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        else if ((fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType) === 'unavailable' &&
            unavailableRef.current) {
            unavailableRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
            (_d = (_c = unavailableRef.current).focus) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
        else if (editPickupPersonState && editPickupPersonRef.current) {
            editPickupPersonRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
            (_f = (_e = editPickupPersonRef.current).focus) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        else if (showGenericError && genericErrorRef.current) {
            genericErrorRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
            (_h = (_g = genericErrorRef.current).focus) === null || _h === void 0 ? void 0 : _h.call(_g);
        }
        else if (showExcludedShipStateError &&
            excludedShipStateErrorRef.current) {
            excludedShipStateErrorRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
            (_k = (_j = excludedShipStateErrorRef.current).focus) === null || _k === void 0 ? void 0 : _k.call(_j);
        }
    }, [
        availableSlotsError,
        fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType,
        editPickupPersonState,
        showGenericError,
        showExcludedShipStateError,
    ]);
    useEffect(function () {
        if (editDeliveryAddressNewOrderId) {
            TrackEditDeliveryAddressAnalytics('purchase history: order details: edit delivery address confirm overlay', 'overlay');
        }
        if (showGenericError) {
            TrackErrorPageEditDeliveryAddressAnalytics('order details', GENERAL_DRAWER_ERROR);
        }
        if (showExcludedShipStateError) {
            TrackErrorPageEditDeliveryAddressAnalytics('order details', CDA_BODFS_EXCLUDED_SHIP_STATE_DRAWER_ERROR);
        }
    }, [
        editDeliveryAddressNewOrderId,
        showGenericError,
        showExcludedShipStateError,
    ]);
    return (React.createElement(React.Fragment, null,
        (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType) === 'unavailable' && (React.createElement("div", { ref: unavailableRef, tabIndex: -1 },
            React.createElement(AlertBanner, { status: "error", headline: "Order Status Unavailable" }, ERR_GENERIC_LATER.message))),
        editPickupPersonState && editPickupPersonState === true && (React.createElement("div", { ref: editPickupPersonRef, tabIndex: -1 },
            React.createElement(AlertBanner, { status: "error" }, EDIT_PICKUP_PERSON_ALERT_MESSAGE.ERROR))),
        alertState && !(alertState === null || alertState === void 0 ? void 0 : alertState.onClose) && !(alertState === null || alertState === void 0 ? void 0 : alertState.alertTitle) && (React.createElement(AlertBanner, { status: (alertState === null || alertState === void 0 ? void 0 : alertState.status) || 'info' }, alertState === null || alertState === void 0 ? void 0 : alertState.alertMessage)),
        alertState && (alertState === null || alertState === void 0 ? void 0 : alertState.onClose) && !(alertState === null || alertState === void 0 ? void 0 : alertState.alertTitle) && (React.createElement(AlertBanner, { onClose: alertState === null || alertState === void 0 ? void 0 : alertState.onClose, status: alertState.status || 'info' }, alertState === null || alertState === void 0 ? void 0 : alertState.alertMessage)),
        alertState && alertState.alertTitle === 'postRemorseFail' && (React.createElement(AlertBanner, { status: (alertState === null || alertState === void 0 ? void 0 : alertState.status) || 'info' },
            "The item(s) scheduled for delivery can't be canceled. See our",
            ' ',
            React.createElement(Link, { className: "sui-underline", href: returnPolicyURL }, "Returns Policy"),
            ' ',
            "for more options.")),
        alertState && alertState.alertTitle === 'postRemorsePartialSuccess' && (React.createElement(AlertBanner, { onClose: alertState === null || alertState === void 0 ? void 0 : alertState.onClose, status: (alertState === null || alertState === void 0 ? void 0 : alertState.status) || 'info' },
            "Item(s) in this order couldn't be canceled. See our",
            ' ',
            React.createElement(Link, { className: "sui-underline", href: returnPolicyURL }, "Returns Policy"),
            ' ',
            "for other options.")),
        updatedBannerState &&
            ((updatedBannerState === null || updatedBannerState === void 0 ? void 0 : updatedBannerState.reschedulable) === reschedulable ||
                updatedBannerState.reschedulable === isDfsReschedulable) &&
            rescheduleBanner(updatedBannerState),
        availableSlotsError && availableSlotsErrorBanner(availableSlotsRef),
        showMultiShipmentBanner && isFirstShipment && (React.createElement(AlertBanner, { onClose: onCloseMultiShipmentBanner, status: "info" }, MULTI_SHIPMENT_BANNER_TEXT)),
        alertState && alertState.alertTitle === 'shippingProvider' && (React.createElement(AlertBanner, { onClose: alertState === null || alertState === void 0 ? void 0 : alertState.onClose, status: (alertState === null || alertState === void 0 ? void 0 : alertState.status) || 'info' }, "The shipping provider has updated the estimated delivery date.")),
        alertState && alertState.alertTitle === 'pendingMACancel' && (React.createElement(AlertBanner, { onClose: alertState === null || alertState === void 0 ? void 0 : alertState.onClose, status: (alertState === null || alertState === void 0 ? void 0 : alertState.status) || 'info' }, "You\u2019ve successfully canceled the following items. The cancellation may take up to 24 hours to be applied to your order.")),
        showBackorderBanner && (React.createElement(AlertBanner, { onClose: onCloseBackorderBanner, status: "info" }, ORDER_STATUS_MESSAGE.BACKORDERED)),
        showGenericError && (React.createElement("div", { ref: genericErrorRef, tabIndex: -1 },
            React.createElement(AlertBanner, { status: "error" }, GENERAL_DRAWER_ERROR))),
        showExcludedShipStateError && (React.createElement("div", { ref: excludedShipStateErrorRef, tabIndex: -1 },
            React.createElement(AlertBanner, { status: "error" }, CDA_BODFS_EXCLUDED_SHIP_STATE_DRAWER_ERROR))),
        editDeliveryAddressPOError && (React.createElement(AlertBanner, { status: "error" }, EDIT_DELIVERY_PO_ERROR)),
        editPickupLocationNewOrderId && (React.createElement(AlertBanner, { status: "info" },
            React.createElement(Typography, null,
                "We have placed order",
                ' ',
                React.createElement(Link, { href: "".concat(location.pathname, "?orderNumber=").concat(editPickupLocationNewOrderId) },
                    "# ",
                    editPickupLocationNewOrderId),
                ' ',
                "with the items for pickup at your new pickup location."))),
        editDeliveryAddressNewOrderId && (React.createElement(AlertBanner, { status: "info" },
            React.createElement(Typography, null,
                "We have placed order",
                ' ',
                React.createElement(Link, { href: "".concat(location.pathname, "?orderNumber=").concat(editDeliveryAddressNewOrderId) },
                    "# ",
                    editDeliveryAddressNewOrderId),
                ' ',
                "with the items for delivery at your new delivery address."))),
        showPickupPersonFraudError && (React.createElement(AlertBanner, { status: "error" }, EDIT_PICKUP_PERSON_ALERT_MESSAGE.FRAUD_ERROR)),
        isBopisOutOfStock && (React.createElement("div", { className: "sui-mb-6" },
            React.createElement(AlertBanner, { headline: "These items have been canceled.", status: "warning" }, REVIEW_PICK_UP_OPTIONS)))));
};
